/* eslint-disable eag/match-named-export */
import {StyleMapping} from '../utils/buildStylesFromSchema';
import {toSizeValue} from '../utils/toSizeValue';
import {toZIndexValue} from './utils/toZIndexValue';

// =============================================================================
// SIZING MAPPINGS (shared between Box and Stack)
// =============================================================================

export const SIZING_STYLE_MAPPINGS: ReadonlyArray<StyleMapping> = [
  {prop: 'width', styleProp: 'width', transform: toSizeValue},
  {prop: 'height', styleProp: 'height', transform: toSizeValue},
  {prop: 'maxWidth', styleProp: 'maxWidth', transform: toSizeValue},
  {prop: 'maxHeight', styleProp: 'maxHeight', transform: toSizeValue},
  {prop: 'minWidth', styleProp: 'minWidth', transform: toSizeValue},
  {prop: 'minHeight', styleProp: 'minHeight', transform: toSizeValue},
];

// =============================================================================
// FLEXBOX ITEM MAPPINGS (shared between Box and Stack)
// =============================================================================

export const FLEX_ITEM_STYLE_MAPPINGS: ReadonlyArray<StyleMapping> = [
  {prop: 'flex', styleProp: 'flex'},
  {prop: 'flexGrow', styleProp: 'flexGrow'},
  {prop: 'flexShrink', styleProp: 'flexShrink'},
  {prop: 'flexBasis', styleProp: 'flexBasis'},
  {prop: 'grow', styleProp: 'flexGrow'},
  {prop: 'shrink', styleProp: 'flexShrink'},
  {prop: 'basis', styleProp: 'flexBasis'},
];

// =============================================================================
// BOX-SPECIFIC MAPPINGS
// =============================================================================

export const BORDER_STYLE_MAPPINGS: ReadonlyArray<StyleMapping> = [
  {prop: 'border', styleProp: 'border'},
  {prop: 'borderTop', styleProp: 'borderTop'},
  {prop: 'borderBottom', styleProp: 'borderBottom'},
  {prop: 'borderLeft', styleProp: 'borderLeft'},
  {prop: 'borderRight', styleProp: 'borderRight'},
];

export const POSITIONING_STYLE_MAPPINGS: ReadonlyArray<StyleMapping> = [
  {prop: 'top', styleProp: 'top', transform: toSizeValue},
  {prop: 'bottom', styleProp: 'bottom', transform: toSizeValue},
  {prop: 'left', styleProp: 'left', transform: toSizeValue},
  {prop: 'right', styleProp: 'right', transform: toSizeValue},
];

export const MISC_STYLE_MAPPINGS: ReadonlyArray<StyleMapping> = [
  {prop: 'opacity', styleProp: 'opacity'},
  {prop: 'transition', styleProp: 'transition'},
  {prop: 'ratio', styleProp: 'aspectRatio'},
  {prop: 'zIndex', styleProp: 'zIndex', transform: toZIndexValue},
];
